import React from "react";
import { Avatar } from "primereact/avatar";
import PropTypes from "prop-types";
import Attachments from "./Attachments";
import "./conversations.scss";
import { downloadFileHandler } from "../../../utils/fileUtils";
import Menu from "~/components/menu/Menu";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";

const Message = ({
  messageInfo,
  formatDate,
  conversation,
  deletedAt,
  setDeleteModal,
  setSelectedMessage,
  relatedType = "",
}) => {
  // const [deleteConfirmation, setDeleteConfirmation] = useState(false)
  const { id: userId, role: userRole } = useSelector((state) => state.login);
  const { id } = useParams();

  const getInitials = (fullName) => {
    const nameArray = fullName.split(" ");
    const firstInitial = nameArray[0] ? nameArray[0].charAt(0) : "";
    const lastInitial =
      nameArray.length > 1 ? nameArray[nameArray.length - 1].charAt(0) : "";
    return `${firstInitial}${lastInitial}`.toUpperCase();
  };
  const role = {
    GXM_ADMIN: "GXM Admin",
    CUSTOMER: "Customer",
    LSP_USER: "LSP",
    GXM_USER: "GXM User",
    GXM_MANAGER: "GXM Manager",
    LSP_MANAGER: "LSP Manager",
    CUSTOMER_MANAGER: "Customer Manager",
  };
  const menuItems = [
    {
      label: "Delete Message",
      icon: "pi pi-trash",
      command: () => {
        setDeleteModal(true);
        setSelectedMessage(conversation);
      },
    },
  ];

  const deletedUser = messageInfo?.updatedBy || messageInfo?.userData;
  return (
    <div className="message-container">
      <Avatar
        label={getInitials(
          [messageInfo?.userData?.first_name, messageInfo?.userData?.last_name]
            .filter(Boolean)
            .join(" "),
        )}
        shape="circle"
        className="avatar"
      />
      <div className="message-content">
        <div className="meta-info-container">
          <div className="meta-info">
            <p className="user-name">
              {`${messageInfo?.userData?.first_name} ${messageInfo?.userData?.last_name} (${role[messageInfo?.userData?.role]})`}{" "}
            </p>
            <p className="date-time">{formatDate(messageInfo?.createdAt)}</p>
          </div>
          {(userId === messageInfo?.created_by ||
            ["GXM_ADMIN"].includes(userRole)) &&
            !deletedAt && (
              <div className="menu-container">
                <Menu menuItems={menuItems} />
              </div>
            )}
        </div>
        {messageInfo?.content && !deletedAt && (
          <p className="message">{messageInfo?.content}</p>
        )}
        {deletedAt && (
          <p className="message deleted-msg">
            Message removed by{" "}
            {`${deletedUser.first_name} ${deletedUser.last_name} (${role[deletedUser.role]}).`}
          </p>
        )}
        {messageInfo?.attachmentData.length > 0 &&
          !deletedAt &&
          messageInfo?.attachmentData.map((file, index) => {
            return (
              <Attachments
                key={index}
                file={{
                  ...file,
                  createdByData: messageInfo?.userData,
                  createdAt: messageInfo?.updatedAt,
                }}
                icon="pi-download"
                progressBar={false}
                fileHandler={() => downloadFileHandler(file)}
                showPreviewIcon={false}
                showDescriptionIcon={true}
                id={id}
                relatedType={relatedType}
              />
            );
          })}
      </div>
    </div>
  );
};

Message.propTypes = {
  messageInfo: PropTypes.any,
  formatDate: PropTypes.func,
  conversation: PropTypes.object,
  deletedAt: PropTypes.string,
  setDeleteModal: PropTypes.func,
  setSelectedMessage: PropTypes.func,
};

export default Message;
